import React, { Component } from "react";
import dayjs from "dayjs";

class MessageA4 extends Component {

    render() {
        // let text = (this.props.entry && this.props.entry.text) || "";
        let text =`<img src="https://cdn.yellowmessenger.com/o57DVJyjbj9b1643360348779.jpg">
        <br> <h2>Border Around Image</h2>
        <p>Use the border property to add a border to an image:</p>`
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    
                 <div dangerouslySetInnerHTML={{__html:text}}></div>
                    <br/>
                </div>
                {  this.props.isLastEntry && this.props.sentTimestamp&& <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.sentTimestamp/1000)).format("DD MMM h:mm a")}</div>}
            </div>
        )
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
        // switch (this.props.message.type) {
        //     // case MessageType.sent: return "s360-message-time-sent";
        //     // case MessageType.received: return "s360-message-time-received";
        //     // case MessageType.info: return "s360-message-time-info";
        //     default: return "";
        // }
    }

    messageBoxClassName = () => {
        return "s360-message-box-received-A4";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-box-sent";
        //     case MessageType.received: return "s360-message-box-received";
        //     case MessageType.info: return "s360-message-box-info";
        //     default: return "";
        // }
    }

    messageContainerClassName = () => {
        return this.props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-cotainer-sent";
        //     case MessageType.received: return "s360-message-cotainer-received";
        //     case MessageType.info: return "s360-message-cotainer-info";
        //     default: return "";
        // }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor}
        // switch (this.props.message.type) {
        //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
        //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        // switch (this.props.message.type) {
        //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }

}

export default MessageA4;